/**
 * Product Card Functionality
 * Handles gallery navigation and color swatches for product cards
 */
(function() {
  'use strict';

  /**
   * Initialize product card galleries
   */
  function initProductCardGalleries() {
    const galleries = document.querySelectorAll('[data-gallery-id]');
    
    galleries.forEach(overlay => {
      const galleryId = overlay.dataset.galleryId;
      
      // Skip if already initialized
      if (overlay.dataset.initialized === 'true') return;
      overlay.dataset.initialized = 'true';
      
      // Find the card wrapper and card element
      const cardWrapper = overlay.parentElement;
      if (!cardWrapper) return;
      
      let card = cardWrapper.querySelector('.card');
      if (!card) {
        const nextSibling = overlay.nextElementSibling;
        if (nextSibling && nextSibling.classList.contains('card')) {
          card = nextSibling;
        } else if (nextSibling) {
          card = nextSibling.querySelector('.card');
          if (!card) {
            const allCards = cardWrapper.querySelectorAll('.card');
            if (allCards.length > 0) {
              card = allCards[0];
            } else {
              return;
            }
          }
        } else {
          return;
        }
      }
      
      // Wait for DOM to settle, then initialize
      setTimeout(() => {
        const images = card.querySelectorAll('.product-card-gallery__image');
        const altImages = card.querySelectorAll('.product-card-gallery__images .product-card-gallery__image');
        const galleryImages = images.length > 0 ? images : altImages;
        
        if (galleryImages.length > 0) {
          initializeGallery(overlay, card, galleryImages);
        }
      }, 100);
    });
  }

  /**
   * Initialize a single gallery
   */
  function initializeGallery(overlay, card, images) {
    const prevBtn = overlay.querySelector('.product-card-gallery__arrow--prev');
    const nextBtn = overlay.querySelector('.product-card-gallery__arrow--next');
    const indicators = overlay.querySelectorAll('.product-card-gallery__indicator');
    
    if (!prevBtn || !nextBtn) return;
    
    // Find which image is currently active
    let currentIndex = 0;
    images.forEach((img, i) => {
      if (img.classList.contains('product-card-gallery__image--active')) {
        currentIndex = i;
      }
    });
    
    // Position arrows based on card__media height
    function positionArrows() {
      const cardMedia = card.querySelector('.card__media');
      if (cardMedia) {
        const mediaHeight = cardMedia.offsetHeight;
        const arrowTop = (mediaHeight / 2);
        prevBtn.style.top = arrowTop + 'px';
        prevBtn.style.transform = 'translateY(-50%)';
        nextBtn.style.top = arrowTop + 'px';
        nextBtn.style.transform = 'translateY(-50%)';
      }
    }
    
    // Position arrows initially and on resize
    positionArrows();
    setTimeout(positionArrows, 200);
    window.addEventListener('resize', positionArrows);
    
    // Show specific image
    function showImage(index) {
      currentIndex = index;
      images.forEach((img, i) => {
        const isActive = i === index;
        img.classList.toggle('product-card-gallery__image--active', isActive);
      });
      indicators.forEach((ind, i) => {
        const isActive = i === index;
        ind.classList.toggle('product-card-gallery__indicator--active', isActive);
        ind.style.background = isActive ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.5)';
      });
    }
    
    // Hover effects - show/hide arrows and indicators
    const cardWrapper = overlay.parentElement;
    cardWrapper.addEventListener('mouseenter', function() {
      prevBtn.style.opacity = '1';
      prevBtn.style.visibility = 'visible';
      nextBtn.style.opacity = '1';
      nextBtn.style.visibility = 'visible';
      indicators.forEach(ind => {
        ind.style.opacity = '1';
        ind.style.visibility = 'visible';
      });
    });
    
    cardWrapper.addEventListener('mouseleave', function() {
      prevBtn.style.opacity = '0';
      prevBtn.style.visibility = 'hidden';
      nextBtn.style.opacity = '0';
      nextBtn.style.visibility = 'hidden';
      indicators.forEach(ind => {
        ind.style.opacity = '0';
        ind.style.visibility = 'hidden';
      });
    });
    
    // Click handlers for arrows
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
      showImage(newIndex);
    });
    
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
      showImage(newIndex);
    });
    
    // Indicator handlers
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showImage(index);
      });
    });
  }

  /**
   * Initialize color swatches
   */
  function initColorSwatches() {
    const swatchContainers = document.querySelectorAll('.card__color-swatches[data-swatches-type]');
    
    swatchContainers.forEach(swatchContainer => {
      // Skip if already initialized
      if (swatchContainer.dataset.swatchesInitialized === 'true') return;
      swatchContainer.dataset.swatchesInitialized = 'true';
      
      const swatches = swatchContainer.querySelectorAll('.card__color-swatch');
      const swatchType = swatchContainer.dataset.swatchesType; // 'metafield' or 'variant'
      
      // For metafield siblings, swatches are links - just add active state styling
      if (swatchType === 'metafield') {
        swatches.forEach(swatch => {
          if (swatch.dataset.active === 'true') {
            swatch.classList.add('active');
          }
        });
        return; // No image swapping for metafield swatches
      }
      
      // For variant-based swatches, handle image swapping
      // Find the card - try multiple selectors
      let card = swatchContainer.closest('.card-wrapper');
      if (!card) card = swatchContainer.closest('.card');
      if (!card) card = swatchContainer.closest('li');
      if (!card) card = swatchContainer.closest('.grid__item');
      if (!card) return;
      
      // Find the media container
      let mediaContainer = card.querySelector('.card__media .media');
      if (!mediaContainer) mediaContainer = card.querySelector('.media');
      if (!mediaContainer) mediaContainer = card.querySelector('.card__media');
      
      // Find the card media (image or video)
      let cardMedia = card.querySelector('.card__media img');
      if (!cardMedia) cardMedia = card.querySelector('.media img');
      if (!cardMedia) cardMedia = card.querySelector('.card__media video');
      if (!cardMedia) cardMedia = card.querySelector('.media video');
      if (!cardMedia) cardMedia = card.querySelector('img:not(.card__color-swatch img)');
      if (!cardMedia) return;
      
      const isVideo = cardMedia.tagName === 'VIDEO';
      
      // Store original media data
      const originalSrc = cardMedia.src;
      const originalSrcset = !isVideo ? (cardMedia.srcset || '') : '';
      const originalType = cardMedia.tagName;
      
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const variantImage = this.dataset.variantImage;
          const variantImageSrcset = this.dataset.variantImageSrcset;
          
          if (variantImage) {
            // Check if we have gallery navigation
            const hasGallery = mediaContainer && mediaContainer.querySelector('.product-card-gallery__images');
            
            if (hasGallery) {
              // Find the first (active) gallery item - might contain video or image
              const firstGalleryItem = mediaContainer.querySelector('.product-card-gallery__image');
              if (firstGalleryItem) {
                // Check if it contains a video or image
                const existingVideo = firstGalleryItem.querySelector('video');
                const existingImage = firstGalleryItem.querySelector('img');
                
                if (existingVideo) {
                  // Replace video with image
                  const newImg = document.createElement('img');
                  newImg.src = variantImage;
                  if (variantImageSrcset) {
                    newImg.srcset = variantImageSrcset;
                  }
                  newImg.className = 'motion-reduce';
                  newImg.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
                  existingVideo.parentNode.replaceChild(newImg, existingVideo);
                } else if (existingImage) {
                  // Update existing image
                  existingImage.src = variantImage;
                  if (variantImageSrcset) {
                    existingImage.srcset = variantImageSrcset;
                  }
                }
              }
            } else if (cardMedia.tagName === 'VIDEO') {
              // No gallery - replace video with image
              const newImg = document.createElement('img');
              newImg.src = variantImage;
              if (variantImageSrcset) {
                newImg.srcset = variantImageSrcset;
              }
              newImg.alt = cardMedia.alt || '';
              newImg.className = cardMedia.className || 'motion-reduce';
              newImg.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
              
              cardMedia.parentNode.replaceChild(newImg, cardMedia);
              cardMedia = newImg;
            } else {
              // Just update the image src
              cardMedia.src = variantImage;
              if (variantImageSrcset) {
                cardMedia.srcset = variantImageSrcset;
              }
            }
            
            // Update active state
            swatches.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
          }
        });
        
        // Also handle mouseenter for quick preview
        swatch.addEventListener('mouseenter', function() {
          const variantImage = this.dataset.variantImage;
          const variantImageSrcset = this.dataset.variantImageSrcset;
          
          if (variantImage) {
            // Check if we have gallery navigation
            const hasGallery = mediaContainer && mediaContainer.querySelector('.product-card-gallery__images');
            
            if (hasGallery) {
              // Find the first (active) gallery item - might contain video or image
              const firstGalleryItem = mediaContainer.querySelector('.product-card-gallery__image');
              if (firstGalleryItem) {
                // Check if it contains a video or image
                const existingVideo = firstGalleryItem.querySelector('video');
                const existingImage = firstGalleryItem.querySelector('img');
                
                if (existingVideo) {
                  // Replace video with image
                  const newImg = document.createElement('img');
                  newImg.src = variantImage;
                  if (variantImageSrcset) {
                    newImg.srcset = variantImageSrcset;
                  }
                  newImg.className = 'motion-reduce';
                  newImg.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
                  existingVideo.parentNode.replaceChild(newImg, existingVideo);
                } else if (existingImage) {
                  // Update existing image
                  existingImage.src = variantImage;
                  if (variantImageSrcset) {
                    existingImage.srcset = variantImageSrcset;
                  }
                }
              }
            } else if (cardMedia.tagName === 'VIDEO') {
              // No gallery - replace video with image
              const newImg = document.createElement('img');
              newImg.src = variantImage;
              if (variantImageSrcset) {
                newImg.srcset = variantImageSrcset;
              }
              newImg.alt = cardMedia.alt || '';
              newImg.className = cardMedia.className || 'motion-reduce';
              newImg.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
              
              cardMedia.parentNode.replaceChild(newImg, cardMedia);
              cardMedia = newImg;
            } else {
              cardMedia.src = variantImage;
              if (variantImageSrcset) {
                cardMedia.srcset = variantImageSrcset;
              }
            }
          }
        });
      });
      
      // Reset to original media when mouse leaves swatch area (if no swatch is active)
      swatchContainer.addEventListener('mouseleave', function() {
        const activeSwatch = swatchContainer.querySelector('.card__color-swatch.active');
        if (!activeSwatch && mediaContainer) {
          // Restore original media (could be video or image)
          if (originalType === 'VIDEO') {
            // Restore video - would need original video HTML
            // For now, just keep the current state since we can't easily restore video
          } else {
            // Restore image
            if (cardMedia && cardMedia.tagName === 'IMG') {
              cardMedia.src = originalSrc;
              if (originalSrcset) {
                cardMedia.srcset = originalSrcset;
              }
            }
          }
        }
      });
    });
  }

  /**
   * Initialize all product card functionality
   */
  function init() {
    initProductCardGalleries();
    initColorSwatches();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify theme editor loads new sections
  document.addEventListener('shopify:section:load', init);
  
  // Also run after a short delay to catch dynamically loaded cards
  setTimeout(init, 500);
})();
